{
  "deviceGate.title": "Exognitos telefonda mobil uygulamada çalışır",
  "deviceGate.lede": "Telefonda Exognitos yerel uygulama olarak çalışır. Yakalamak, planlamak ve gözden geçirmek için uygulamayı kur; hesabın ve içindeki her şey aynı kalır.",
  "deviceGate.downloads": "Uygulamayı indir",
  "deviceGate.android": "Android",
  "deviceGate.ios": "iPhone",
  "deviceGate.googlePlay": "Google Play'den indir",
  "deviceGate.appStore": "App Store'dan indir",
  "deviceGate.comingSoon": "Yakında",
  "deviceGate.comingSoonHint": "Mağaza sayfası henüz yayımlanmadı.",
  "deviceGate.accountHeading": "Zaten hesabın var mı?",
  "deviceGate.signIn": "Giriş yap",
  "deviceGate.register": "Hesap oluştur",
  "deviceGate.settings": "Hesap ayarları",
  "deviceGate.accountHint": "Giriş, kayıt ve hesap ayarları burada da çalışır; mobil uygulamalar hesabını böyle yetkilendirir.",
  "deviceGate.language": "Dil",
  "deviceGate.continueInBrowser": "Yine de tarayıcıda devam et",
  "deviceGate.continueInBrowserHint": "Tam arayüz daha büyük bir ekran için tasarlandı. Bu seçim bu cihazda hatırlanır.",
  "deviceGate.documentTitle": "Mobil uygulama"
}
